// extracted by mini-css-extract-plugin
export default {"balances":"AccountBalance_balances__4dohN"};